<av-card-row-responsive [icon]="icon">
  <ng-container card-row-title>{{ title }}</ng-container>
  <ng-container card-row-subtitle>
    {{ transform().createdAt | dayjsFormat : "MMM D YYYY, h:mm a" }}
  </ng-container>
  <ng-container card-row-actions>
    @if (!isCompleted) {
    <!-- <av-spinner size="xs" *ngIf="!isCompleted"></av-spinner> -->
    <app-composition-state
      [state]="transform().state.toUpperCase()"
    ></app-composition-state>
    } @if (isCompleted) { @if (canRequestFormattedTranscript) {
    <av-tooltip message="Content">
      <button
        [attr.aria-label]="'Content' | translate"
        avButton
        size="xs"
        ofType="icon"
        color="link"
        (click)="toggleContent()"
        [loading]="isLoadingContent()"
        [disabled]="isLoadingContent()"
      >
        <av-icon
          [class.expanded]="isContentExpanded()"
          size="sm"
          name="chevron-down"
        ></av-icon>
      </button>
    </av-tooltip>
    <div class="separator"></div>
    }
    <av-confirm
      [open]="confirmRemove()"
      (confirmed)="removeTransform()"
      (canceled)="confirmRemove.set(false)"
      arrow="bottom-right"
    >
      <button
        avButton
        ofType="icon"
        color="danger"
        size="xxs"
        [loading]="isRemoveLoading()"
        (click)="confirmRemove.set(true)"
      >
        <av-icon size="xs" name="trash"></av-icon>
      </button>
      <span confirmTitle translate>Are you sure?</span>
      <div confirmBody>
        <!-- {{
          "You can only export one language per recording. The existing transcript will be removed."
          | translate
          }} -->
      </div>
    </av-confirm>
    @if (!canRequestFormattedTranscript && !url()) {
    <av-tooltip message="Get download link">
      <button
        [attr.aria-label]="'Get download link' | translate"
        avButton
        ofType="icon"
        color="link"
        size="xs"
        data-tid="composition/download"
        [loading]="isLoadingURL()"
        (click)="getURL()"
      >
        <av-icon size="sm" name="link"></av-icon>
      </button>
    </av-tooltip>
    } @if (canRequestFormattedTranscript) {
    <av-tooltip message="Download">
      <button
        [attr.aria-label]="'Download' | translate"
        avButton
        size="xs"
        ofType="icon"
        color="link"
        (click)="download()"
      >
        <av-icon size="sm" name="document-download"></av-icon>
      </button>
    </av-tooltip>
    } } @if (!!url()) {
    <av-tooltip message="Download">
      <a
        [attr.aria-label]="'Download' | translate"
        avButton
        size="xs"
        ofType="icon"
        color="link"
        [href]="url()"
        download="Sentiment"
        target="_blank"
      >
        <av-icon size="sm" name="document-download"></av-icon>
      </a>
    </av-tooltip>
    <av-copy-clipboard [url]="url()" size="xs"></av-copy-clipboard>
    }
  </ng-container>
</av-card-row-responsive>

@if (isContentExpanded()) {
<av-card-body class="content" type="spotlight">
  <av-copy-clipboard
    size="xs"
    class="card-action"
    [tooltipLabel]="'Copy to clipboard' | translate"
    [url]="copyData()"
  ></av-copy-clipboard>
  @if (isTranslate) {
  <app-composition-transcript-content
    [data]="translateData()"
  ></app-composition-transcript-content>
  } @if (!isTranslate) {
  <div
    class="full-width"
    [innerHTML]="transformData()?.result | markdown"
  ></div>
  }
</av-card-body>
}
